import React from 'react';

const SubmittingStep = () => (
  <div className="flex flex-col items-center justify-center py-12">
    <div className="animate-spin rounded-full h-10 w-10 border-2 border-gray-200 border-t-indigo-600 mb-6" />
    <p className="text-gray-600 text-sm">Submitting your interview experience...</p>
  </div>
);

export default SubmittingStep;
